export enum Identifier {
  GLN = 'gln',
  CVR = 'cvr',
}
